var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputClear = function SvgInputClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 7,
    y: 2,
    fill: "#AAA",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.775 6.775a.37.37 0 0 1 .524 0l2.7 2.701 2.702-2.701a.37.37 0 0 1 .524.524l-2.701 2.7 2.7 2.702a.37.37 0 0 1-.523.524L15 10.524l-2.701 2.7a.37.37 0 0 1-.524-.523L14.476 10l-2.701-2.701a.37.37 0 0 1 0-.524",
    clipRule: "evenodd"
  })));
};
export default SvgInputClear;